<mat-expansion-panel class="expansion-panel">
  <mat-expansion-panel-header>
    <mat-panel-title>{{
      'ASSOCIATION_PANEL.TITLE' | translateForCrmObject: associatedObject() | async
    }}</mat-panel-title>
  </mat-expansion-panel-header>
  @defer {
    <button
      mat-stroked-button
      color="primary"
      class="button-association-card"
      (click)="addAssociation()"
      [disabled]="isMultiLocation()"
    >
      <mat-icon>add</mat-icon>
      {{ 'ASSOCIATION_PANEL.ADD_ASSOCIATION' | translateForCrmObject: associatedObject() | async }}
    </button>
    @if (cards$ | async; as cards) {
      @for (card of cards; track card) {
        @if (card?.associationId) {
          <mat-card class="card">
            <mat-card-header class="card-header">
              @if (card.avatar) {
                <glxy-avatar mat-card-avatar width="36" [src]="card.avatar" [icon]="card.icon" />
              }
              @if (card.name) {
                <mat-card-title class="name">
                  @if (card.profileUrl && showAssociationLink()) {
                    <a [routerLink]="card.profileUrl">
                      {{ card.name }}
                    </a>
                  } @else {
                    <span>
                      {{ card.name }}
                    </span>
                  }
                </mat-card-title>
              }
              <mat-card-subtitle class="card-sub-header">
                @if (customHeaderContent()) {
                  <ng-container
                    [ngTemplateOutlet]="customHeaderContent() ?? null"
                    [ngTemplateOutletContext]="{ card: card }"
                  ></ng-container>
                }
              </mat-card-subtitle>
              <button mat-icon-button matTooltip="Actions" class="more-actions-icon" [matMenuTriggerFor]="menu">
                <mat-icon>more_vert</mat-icon>
              </button>
              <mat-menu [xPosition]="'before'" #menu="matMenu">
                @if ((primaryAssociationId$ | async) !== card.associationId && requiresPrimaryAssociation()) {
                  <button mat-menu-item (click)="setAsPrimary(card)">
                    {{
                      'ASSOCIATION_PANEL.SET_PRIMARY_MODAL.RADIO_BUTTON_TEXT'
                        | translateForCrmObject: associatedObject()
                        | async
                    }}
                  </button>
                }
                <button mat-menu-item (click)="editTags(card)">
                  {{ 'ASSOCIATIONS.ACTIONS.EDIT_TAGS' | translate }}
                </button>
                @if (!isMultiLocation()) {
                  <button mat-menu-item (click)="removeAssociation(card)">
                    {{ 'ASSOCIATIONS.ACTIONS.REMOVE' | translate }}
                  </button>
                }
                @for (action of customActions(); track action) {
                  <button mat-menu-item (click)="action.callback(card)">
                    <span class="action-button"
                      >{{ action.label | translate }}
                      @if (action.icon) {
                        <mat-icon class="icon">{{ action.icon }}</mat-icon>
                      }
                    </span>
                  </button>
                }
              </mat-menu>
            </mat-card-header>
            <mat-card-content class="content">
              @if (customCardContent()) {
                <ng-container
                  [ngTemplateOutlet]="customCardContent() ?? null"
                  [ngTemplateOutletContext]="{ card: card }"
                ></ng-container>
              }
              @if (card.tags?.length > 0) {
                <crm-common-association-card-content [iconName]="'local_offer'">
                  <crm-tags [tags]="card.tags || []"></crm-tags>
                </crm-common-association-card-content>
              }
            </mat-card-content>
          </mat-card>
        }
      }
    } @else {
      <div class="loading-container">
        <glxy-loading-spinner [inline]="true" />
      </div>
    }
  } @loading {
    <div class="loading-container">
      <glxy-loading-spinner [inline]="true" />
    </div>
  }
</mat-expansion-panel>
